export const phiDocs = {
  name: 'phi',
  category: 'Constants',
  syntax: [
    'phi'
  ],
  description: 'Phi is the golden ratio. Two quantities are in the golden ratio if their ratio is the same as the ratio of their sum to the larger of the two quantities. Phi is defined as `(1 + sqrt(5)) / 2` and is approximately 1.618034...',
  examples: [
    'phi'
  ],
  seealso: []
}
